module.exports = __webpack_public_path__ + "img/icon-hibaby.45554730.png";